import { RadioButton, ReactEasyForm } from "@aeco-cloud/react-easy-form";
import settings from "@styles/settings";
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { TextContext } from "../../../pages/bepaal-statuut";
import { Label, NavigationButtons, Question, Section } from "../../form-layout";
import StepBody from "../../form-layout/StepBody";
import { SendContext } from "../BepaalStatuut";

const Unemployed = () => {
  const send = useContext(SendContext);
  const text = useContext(TextContext);
  const form = useForm();

  const onSubmit: SubmitHandler<any> = (data) => {
    const result =
      data.half === "true" && data.days39 === "true"
        ? "secondaryActivityTrue"
        : "secondaryActivityFalse";
    data.result = result;
    send({ type: "NEXT", data: data });
  };

  const onBack = () => {
    send({ type: "BACK" });
  };

  return (
    <ReactEasyForm form={form}>
      <StepBody>
        <Section>
          <Question>
            <Label label={text.unemployed_half_label} />
            <RadioButton
              name="half"
              minButtonWidth="240px"
              {...settings.selectButtonsProps}
              options={[
                { value: "true", label: text.general_yes },
                { value: "false", label: text.general_no },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
          <Question showIf={form.watch("half") === "true"}>
            <Label label={text.unemployed_days39_label} />
            <RadioButton
              name="days39"
              minButtonWidth="240px"
              {...settings.selectButtonsProps}
              options={[
                { value: "true", label: text.general_yes },
                { value: "false", label: text.general_no },
              ]}
              rules={{
                required: text.general_requiredQuestion,
              }}
            />
          </Question>
        </Section>
      </StepBody>

      <NavigationButtons onBack={onBack} onNext={form.handleSubmit(onSubmit)} />
    </ReactEasyForm>
  );
};
export default Unemployed;
